import { render, staticRenderFns } from "./ClientStats.vue?vue&type=template&id=50660891&scoped=true&"
import script from "./ClientStats.vue?vue&type=script&lang=js&"
export * from "./ClientStats.vue?vue&type=script&lang=js&"
import style0 from "./ClientStats.vue?vue&type=style&index=0&id=50660891&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50660891",
  null
  
)

export default component.exports